import { useMutation, useQueryClient } from '@tanstack/react-query'
import { deleteConversation } from '../../../data/statsAssistant'
import { UserFriendlyError } from '../../../model/Error'
import { statsAssistantKeys } from './statsAssistant.keys'

export const useDeleteConversation = () => {
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: async (ulid: string) => {
      const { ok } = await deleteConversation(ulid)
      if (!ok) {
        throw new UserFriendlyError(
          'error',
          'Impossible de supprimer la conversation',
          'Une erreur technique s’est produite',
        )
      }
      return ulid
    },
    onSuccess: (ulid) => {
      queryClient.removeQueries({ queryKey: statsAssistantKeys.conversation(ulid) })
      queryClient.invalidateQueries({ queryKey: statsAssistantKeys.conversationsRoot })
    },
  })
}
